import { MinusCircleOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataRefreshContext } from "../../contexts/dataRefreshContext";
import { useUnassignSCBOneDeviceFromOrganization } from "../../api/api.scb-one";

interface UnassignSCBOneDevicesButtonProps {
  organizationId: string;
  selectedDeviceSerials: string[];
  onClearSelectedBeaconIds(): void;
}

export function UnassignSCBOneDevicesButton({
  organizationId,
  selectedDeviceSerials,
  onClearSelectedBeaconIds,
}: UnassignSCBOneDevicesButtonProps) {
  const { t } = useTranslation();
  const [isUnassigning, setIsUnassigning] = useState(false);

  const unassignDevicesFromOrganization =
    useUnassignSCBOneDeviceFromOrganization();

  const dataRefreshContext = useContext(DataRefreshContext);

  const onUnassignBeaconsFromOrganization = async () => {
    try {
      setIsUnassigning(true);
      await unassignDevicesFromOrganization({
        serials: selectedDeviceSerials,
        organizationId,
      });
      onClearSelectedBeaconIds();
      dataRefreshContext.refresh();
    } catch {
      console.error("Failed to unassign beacons from organization");
    } finally {
      setIsUnassigning(false);
    }
  };

  return (
    <>
      <Badge count={selectedDeviceSerials.length}>
        <Button
          danger
          disabled={selectedDeviceSerials.length === 0}
          loading={isUnassigning}
          onClick={onUnassignBeaconsFromOrganization}
        >
          <MinusCircleOutlined />
          {selectedDeviceSerials.length > 1
            ? t("scb-one:unassign-device-plural")
            : t("scb-one:unassign-device")}
        </Button>
      </Badge>
    </>
  );
}
